<template>
  <a href="#" :class="{ muted: !isActive }" v-if="show" @click.prevent="click('copy')">
    <aw-icon icon="copy" class="w-5 h-5"></aw-icon>
    {{$t('Copy')}}
  </a>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import MoveCopy from '../../mixins/MoveCopy'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
    MoveCopy,
  ],
  computed: {
    show() {
      return this.bcDocumentStore.document.can_edit && this.bcDocumentStore.edit
    },
    isActive() {
      return this.bcSelectedStore.listFullySelected.length > 0
    },
    ...mapStores(useBcSelectedStore)
  },
}
</script>

<style lang="scss" scoped></style>
